import { Route, RouteProps } from "react-router-dom";

// components
import PrivateRoute from "./PrivateRoute";
 
import {
  Dashboard,
  CreateSheetPayment,
  CustomerList,
  InsertUpdateCustomer,
  OrderReport,
  Parameters,
  PaymentLinks,
  PaymentSyncErp,
  PosConnectionSettings,
  PosDetail,
  PaymentThreedGate,
  CronJobRecords,
  CronJobSettings,
  OrderDetail,
  LoginPage,
  UserProfile,
  PaymentPageV1,
  ForgotPassword,
  ResetPassword,
  SabeeappBookingList,
  UserList,
  InsertUpdateUser,
  UserCustomerMatch,
  InsertCustomerWithExcel,
  Error404,
  CreateFreePayment,
  UnlimitedPaymentLink,
  CreatePassword,
  PaymentSetList,
  InsertUpdatePaymentSet,
  OrderInstallmentsReport
} from "../features/pages"   

export interface RoutesProps {
  path: RouteProps["path"];
  name?: string;
  element?: RouteProps["element"];
  route?: any;
  exact?: boolean;
  icon?: string;
  header?: string;
  roles?: string[];
  children?: RoutesProps[];
  passsubfolder?: boolean;
  passTenantControl?: boolean; 
  menuKey?:string
}

 
const dashboardRoutes: RoutesProps = {
  path: "/",
  name: "Dashboards",
  icon: "home",
  header: "Navigation",
  children: [
    {
      path: '/dashboard',
      name: "anasayfa",
      menuKey:"anasayfa",
      element: <Dashboard />,
      route: PrivateRoute,
    },
    {
      path: '/toplu-odeme-baslat',
      name: "toplu-odeme-baslat",
      element: <CreateSheetPayment />,
      route: PrivateRoute,
      menuKey:"toplu-odeme-baslat",
    },
    {
      path: '/musteri-listesi',
      name: "musteri-listesi",
      element: <CustomerList />,
      route: PrivateRoute,
      menuKey:"musteri-listesi",
    },
    {
      path: '/musteri-guncelle/:customerId',
      name: "musteri-guncelle",
      element: <InsertUpdateCustomer />,
      route: PrivateRoute,
      menuKey:"musteri-guncelle",
    },
    {
      path: '/musteri-ekle',
      name: "musteri-ekle",
      element: <InsertUpdateCustomer />,
      route: PrivateRoute,
      menuKey:"musteri-ekle",
    },
    {
      path: "/musteri-ekle-excel",
      name: "musteri-ekle-excel",
      element: <InsertCustomerWithExcel />,
      route: PrivateRoute,
      menuKey:"musteri-ekle-excel",
    },
    {
      path: '/kullanici-listesi',
      name: 'kullanici-listesi',
      element: <UserList />,
      route: PrivateRoute,
      menuKey:"kullanici-listesi",
    },
    {
      path: '/kullanici-ekle',
      name: 'kullanici-ekle',
      element: <InsertUpdateUser/>,
      route: PrivateRoute,
      menuKey:"kullanici-ekle", 
    },
    {
      path: '/kullanici-guncelle/:userId',
      name: 'kullanici-guncelle',
      element: <InsertUpdateUser/>,
      route: PrivateRoute,
      menuKey:"kullanici-guncelle", 
    },
    {
      path: '/kullanici-musteri-yetkilendir/:userId',
      name: 'kullanici-musteri-yetkilendir-guncelle',
      element: <UserCustomerMatch/>,
      route: PrivateRoute,
      menuKey:"kullanici-musteri-yetkilendir-guncelle",
    },
    {
      path: '/kullanici-musteri-yetkilendir',
      name: 'kullanici-musteri-yetkilendir',
      element: <UserCustomerMatch/>,
      route: PrivateRoute,
      menuKey:"kullanici-musteri-yetkilendir",
    },
    {
      path: '/islem-raporu',
      name: "islem-raporu",
      element: <OrderReport />,
      route: PrivateRoute,
      menuKey:"islem-raporu",
    },
    {
      path: '/parametreler',
      name: "parametreler",
      element: <Parameters />,
      route: PrivateRoute,
      menuKey:"parametreler",
    },
    {
      path: '/gonderilen-odeme-linkleri',
      name: "gonderilen-odeme-linkleri",
      element: <PaymentLinks />,
      route: PrivateRoute,
      menuKey:"gonderilen-odeme-linkleri",
    },
    {
      path: '/odeme-sayfasi',
      name: "odeme-sayfasi",
      element: <PaymentPageV1 />,
      route: PrivateRoute,
      menuKey:"odeme-sayfasi",
    },
    {
      path: '/tahsilat-mutabakati',
      name: "tahsilat-mutabakati",
      element: <PaymentSyncErp />,
      route: PrivateRoute,
      menuKey:"tahsilat-mutabakati",
    },
    {
      path: '/pos-baglanti-ayarlari',
      name: "pos-baglanti-ayarlari",
      element: <PosConnectionSettings />,
      route: PrivateRoute,
      menuKey:"pos-baglanti-ayarlari",
    },
    {
      path: '/pos-baglanti-ayarlari/:bankId',
      name: "pos-baglanti-ayarlari",
      element: <PosDetail />,
      route: PrivateRoute,
      menuKey:"pos-baglanti-ayarlari",
    },
    {
      path: '/odeme-detayi/:orderCode',
      name: "odeme-detayi",
      element: <OrderDetail />,
      route: PrivateRoute,
      menuKey:"odeme-detayi",
    },
    {
      path: '/profile',
      name: "profile",
      element: <UserProfile />,
      route: PrivateRoute,
      menuKey:"profile",
    },
    {
      path: '/serbest-odeme-baslat',
      name: "serbest-odeme-baslat",
      element: <CreateFreePayment />,
      route: PrivateRoute,
      menuKey:"serbest-odeme-baslat",
    },
    {
      path: '/zamanlanmis-gorevler',
      name: "zamanlanmis-gorevler",
      element: <CronJobRecords />,
      route: PrivateRoute,
      menuKey:"zamanlanmis-gorevler",
    },
    {
      path: '/zamanlanmis-gorev-tanimi',
      name: "zamanlanmis-gorev-tanimi",
      element: <CronJobSettings />,
      route: PrivateRoute,
      menuKey:"zamanlanmis-gorev-tanimi",
    },
    {
      path: '/rezervasyon-listesi',
      name: "rezervasyon-listesi",
      element: <SabeeappBookingList />,
      route: PrivateRoute,
      menuKey:"rezervasyon-listesi",
    },
    {
      path: '/suresiz-odeme-linki',
      name: 'suresiz-odeme-linki',
      element: <UnlimitedPaymentLink />,
      route: PrivateRoute,
      menuKey: 'suresiz-odeme-linki'
    },
    {
      path: '/odeme-setleri',
      name: 'odeme-setleri',
      element: <PaymentSetList />,
      menuKey: 'odeme-setleri'
    },
    {
      path: '/odeme-seti-ekle',
      name: 'odeme-seti-ekle',
      element: <InsertUpdatePaymentSet/>,
      route: PrivateRoute,
      menuKey:"odeme-seti-ekle", 
    },
    {
      path: '/odeme-seti-guncelle/:paymentSetId',
      name: 'odeme-seti-guncelle',
      element: <InsertUpdatePaymentSet/>,
      route: PrivateRoute,
      menuKey:"odeme-seti-guncelle", 
    },
    {
      path: '/geri-odeme-raporlari',
      name: 'geri-odeme-raporlari',
      element: <OrderInstallmentsReport/>,
      route: PrivateRoute,
      menuKey:"geri-odeme-raporlari",
    }
  ],
};

 
const authRoutes: RoutesProps[] = [
  {
    path: "/login",
    name: "Login",
    element: <LoginPage />,
    route: Route,
  },
  {
    path: "/sifremi-unuttum",
    name: "forgotPass",
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: "/resetpassword",
    name: "resetpassword",
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: '/odeme-yonlendirme',
    name: "odeme-yonlendirme",
    element: <PaymentThreedGate />,
    route: PrivateRoute,
    passsubfolder: true,
    passTenantControl: true
  },
  {
    path: '/paymentpage',
    name: "paymentpage",
    element: <PaymentPageV1 />,
    route: PrivateRoute,
  },
  {
    path: '/apipayment',
    name: "apiPaymentPage",
    element: <PaymentPageV1 />,
    route: PrivateRoute,
    passsubfolder: true,
    passTenantControl: true
  },
  {
    path: '/uyeliksiz-odeme',
    name: "publicPayment",
    element: <PaymentPageV1 />,
    route: PrivateRoute,
  },
  {
    path: '/link-odeme',
    name: "publicPayment",
    element: <PaymentPageV1 />,
    route: PrivateRoute,
  },
  {
    path: '/sifre-olustur',
    name: 'sifre-olustur',
    element: <CreatePassword />,
    route: Route,
  }
];

// public routes
const otherPublicRoutes :RoutesProps[]= [
  {
    path: "*",
    name: "Error - 404",
    element: <Error404 />,
    route: Route,
    passTenantControl:false,
  },
  {
    path: "/404",
    name: "Error - 404",
    element: <Error404 />,
    passsubfolder:true,
    passTenantControl:true,
    route: Route,
  },
];

// flatten the list of all nested routes
const flattenRoutes = (routes: RoutesProps[]) => {
  let flatRoutes: RoutesProps[] = [];

  routes = routes || [];
  routes.forEach((item: RoutesProps) => {
    flatRoutes.push(item);
    if (typeof item.children !== "undefined") {
      flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
    }
  });
  return flatRoutes;
};

// All routes
const authProtectedRoutes = [
  dashboardRoutes,
];
const publicRoutes = [...authRoutes, ...otherPublicRoutes];

const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);
export {
  publicRoutes,
  authProtectedRoutes,
  authProtectedFlattenRoutes,
  publicProtectedFlattenRoutes,
};
